// Header/Navigation component
export function createHeader() {
  return `
<nav class="shadow-sm border-b border-gray-200 sticky top-0 z-50" style="background-color: #fefdf5;">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-16">
      <!-- Logo -->
      <div class="flex-shrink-0" style="margin-left: 50px;">
        <a href="/" data-route="/" class="transition-opacity duration-200 hover:opacity-80">
          <img id="header-logo" src="/images/Logo.webp" alt="EPC Spain Homes" class="h-12 w-auto rounded-lg">
        </a>
      </div>

      <!-- Desktop Navigation -->
      <div class="hidden md:block">
        <div class="ml-10 flex items-baseline space-x-1">

          <!-- Compare -->
          <a href="/" data-route="/"
             class="nav-link text-gray-600 hover:text-primary-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200">
            Compare
          </a>

          <!-- How it works (dropdown) -->
          <div class="relative group">
            <a href="/how-it-works/" data-route="/how-it-works/"
               class="nav-link text-gray-600 hover:text-primary-600 px-3 py-2 rounded-md text-sm font-medium flex items-center transition-colors duration-200">
              How it works
              <svg class="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </a>
            <div class="dropdown-menu absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 z-50 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
              <div class="py-2">
                <a href="/how-it-works/" data-route="/how-it-works/" class="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-600">The process</a>
                <a href="/epc/" data-route="/epc/" class="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-600">Energy certificates</a>
                <a href="/improvements-report/" data-route="/improvements-report/" class="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-600">Improvement reports</a>
              </div>
            </div>
          </div>

          <!-- About us (dropdown) -->
          <div class="relative group">
            <a href="/about/" data-route="/about/"
               class="nav-link text-gray-600 hover:text-primary-600 px-3 py-2 rounded-md text-sm font-medium flex items-center transition-colors duration-200">
              About us
              <svg class="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </a>
            <div class="dropdown-menu absolute left-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
              <div class="py-2">
                <a href="/about/" data-route="/about/" class="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-600">About EPCspainhomes.com</a>
                <a href="/why/" data-route="/why/" class="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-600">Why EPCspainhomes.com?</a>
                <a href="/advisors/" data-route="/advisors/" class="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-600">All energy advisors</a>
              </div>
            </div>
          </div>

          <!-- Certificate news -->
          <a href="/blog/" data-route="/blog/"
             class="nav-link text-gray-600 hover:text-primary-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200">
            Certificate news
          </a>
        </div>
      </div>

      <!-- 🎧 Customer service button (desktop) -->
      <button id="openDrawer"
              class="hidden md:flex items-center gap-2 bg-white hover:bg-green-50 border border-gray-200 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:text-green-600 transition-all duration-200 shadow-sm">
        🎧 <span>Customer service</span>
      </button>
      
                <!-- 🌍 Language Selector -->
          <div class="flex items-center space-x-1 ml-6">
            <div class="flag active cursor-pointer p-2 rounded-lg hover:bg-gray-100 transition-all duration-200 opacity-70 hover:opacity-100 border-2 border-transparent" data-lang="es">
              <a href="https://ceecasasespana.com" target="_self">
                <img src="/flags/4x3/es.svg" alt="Español" class="w-6 h-6 object-cover rounded-full">
              </a>
            </div>

          </div>

      <!-- Mobile menu button -->
      <div class="md:hidden">
        <button type="button" class="mobile-menu-button bg-gray-100 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500" aria-label="Open menu">
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile Menu -->
  <div class="mobile-menu hidden md:hidden bg-gray-50 border-t border-gray-200">
    <div class="px-2 pt-2 pb-3 space-y-2 sm:px-3">
      <a href="/compare/" data-route="/compare/" class="nav-link block text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md text-base font-medium">Compare</a>

      <!-- How it works (accordion) -->
      <div class="mobile-menu-section">
        <button class="mobile-menu-toggle w-full text-left px-3 py-2 text-base font-semibold text-gray-800 flex items-center justify-between" data-target="mm-how">
          How it works
          <svg class="h-5 w-5 transform transition-transform duration-200"><path fill="currentColor" d="M7 10l5 5 5-5z"/></svg>
        </button>
        <div id="mm-how" class="mobile-submenu hidden pl-4 space-y-1">
          <a href="/how-it-works/" data-route="/how-it-works/" class="nav-link block text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md text-sm">The process</a>
          <a href="/book-epc/" data-route="/book-epc/" class="nav-link block text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md text-sm">Energy certificates</a>
          <a href="/improvements-report/" data-route="/improvements-report/" class="nav-link block text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md text-sm">Improvement reports</a>
        </div>
      </div>

      <!-- About us (accordion) -->
      <div class="mobile-menu-section">
        <button class="mobile-menu-toggle w-full text-left px-3 py-2 text-base font-semibold text-gray-800 flex items-center justify-between" data-target="mm-about">
          About us
          <svg class="h-5 w-5 transform transition-transform duration-200"><path fill="currentColor" d="M7 10l5 5 5-5z"/></svg>
        </button>
        <div id="mm-about" class="mobile-submenu hidden pl-4 space-y-1">
          <a href="/about/" data-route="/about/" class="nav-link block text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md text-sm">About EPCspainhomes.com</a>
          <a href="/why-us/" data-route="/why-us/" class="nav-link block text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md text-sm">Why EPCspainhomes.com?</a>
          <a href="/advisors/" data-route="/advisors/" class="nav-link block text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md text-sm">All energy advisors</a>
        </div>
      </div>

      <a href="/blog/" data-route="/blog/" class="nav-link block text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md text-base font-medium">Certificate news</a>

      <!-- 🎧 Customer service button (mobile) -->
      <div class="pt-3 border-t border-gray-200 px-2 pb-3">
        <button id="openDrawerMobile" class="w-full flex items-center justify-center gap-2 bg-green-600 text-white rounded-lg py-2 text-base font-medium hover:bg-green-700 transition-colors duration-200">
          🎧 Customer service
        </button>
      </div>
    </div>
  </div>
</nav>

<!-- Overlay -->
<div id="overlay" class="hidden fixed inset-0 bg-black bg-opacity-40 z-40 transition-opacity"></div>

<!-- Drawer -->
<div id="drawer" class="fixed top-0 right-0 w-full md:w-1/2 h-full bg-white shadow-xl transform translate-x-full transition-transform duration-300 z-50 overflow-y-auto">
  <div class="p-6">
    <div class="flex justify-between items-start">
      <h2 class="text-2xl font-bold">Need help?</h2>
      <button id="closeDrawer" class="text-gray-500 hover:text-gray-800 text-2xl" aria-label="Close">&times;</button>
    </div>
    <p class="text-green-600 mt-1">We are here to help you</p>

    <div class="mt-4 bg-green-50 rounded-xl p-4 flex items-center gap-4">
      <img src="/images/support-agent.webp" alt="Customer service" class="w-14 h-14 rounded-full object-cover">
      <div>
        <h3 class="font-semibold text-lg">Customer service</h3>
        <p class="text-sm text-gray-600">Mon - Fri: 09:00 - 19:00</p>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
      <div class="border rounded-xl p-4">
        <p class="font-semibold mb-1">📞 Call us</p>
        <a href="tel:626806552" class="text-blue-600 font-medium hover:underline">626 80 65 52</a>
        <p class="text-sm text-green-600 mt-1">• Available until 19:00</p>
      </div>
      <div class="border rounded-xl p-4">
        <p class="font-semibold mb-1">💬 Send us a WhatsApp</p>
        <a href="https://web.whatsapp.com/" class="text-blue-600 font-medium hover:underline">Open WhatsApp</a>
        <p class="text-sm text-green-600 mt-1">• Available until 19:00</p>
      </div>
      <div class="border rounded-xl p-4">
        <p class="font-semibold mb-1">📧 Send us an email</p>
        <a href="mailto:info@EPCspainhomes.com" class="text-blue-600 font-medium hover:underline">Support</a>
        <p class="text-sm text-green-600 mt-1">• 24 hours a day</p>
      </div>
    </div>

    <div class="mt-8">
      <h4 class="font-bold text-lg mb-2">Frequently asked questions:</h4>
      <details class="mb-2">
        <summary class="cursor-pointer font-medium">How does EPCspainhomes.com work?</summary>
        <p class="text-gray-600 mt-1">We compare certified energy advisors in your region...</p>
      </details>
      <details class="mb-2">
        <summary class="cursor-pointer font-medium">What is an energy certificate?</summary>
        <p class="text-gray-600 mt-1">The energy certificate shows how efficient your home is...</p>
      </details>
    </div>
  </div>
</div>

  `;
}

// Initialize header functionality
export function initializeHeader() {
  // Language switcher
  const flags = document.querySelectorAll(".flag");
  flags.forEach((flag) => {
    flag.addEventListener("click", () => {
      const selectedLang = flag.dataset.lang;
      flags.forEach((f) => {
        f.classList.remove("active", "opacity-100", "border-primary-500");
        f.classList.add("opacity-70", "border-transparent");
      });
      flag.classList.add("active", "opacity-100", "border-primary-500");

      const headerLogo = document.getElementById("header-logo");
      if (headerLogo) headerLogo.src = selectedLang === "es" ? "/images/Logo.webp" : "/images/Logo.webp";
      if (window.i18n) window.i18n.setLanguage(selectedLang);
    });
  });

  // Mobile menu
  const mobileMenuButton = document.querySelector(".mobile-menu-button");
  const mobileMenu = document.querySelector(".mobile-menu");
  if (mobileMenuButton && mobileMenu) {
    mobileMenuButton.addEventListener("click", () => mobileMenu.classList.toggle("hidden"));

    // mobile accordions
    const mmToggles = mobileMenu.querySelectorAll(".mobile-menu-toggle");
    mmToggles.forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-target");
        const submenu = document.getElementById(id);
        const icon = btn.querySelector("svg");
        submenu?.classList.toggle("hidden");
        icon?.classList.toggle("rotate-180");
      });
    });

    // close on link click
    mobileMenu.querySelectorAll("a[data-route]").forEach((a) => {
      a.addEventListener("click", () => mobileMenu.classList.add("hidden"));
    });
  }

  // Drawer
  const drawer = document.getElementById("drawer");
  const overlay = document.getElementById("overlay");
  const openDrawerDesktop = document.getElementById("openDrawer");
  const openDrawerMobile = document.getElementById("openDrawerMobile");
  const closeDrawerBtn = document.getElementById("closeDrawer");

  function openDrawerFunc() {
    drawer.classList.remove("translate-x-full");
    overlay.classList.remove("hidden");
    document.documentElement.classList.add("overflow-hidden");
  }
  function closeDrawerFunc() {
    drawer.classList.add("translate-x-full");
    overlay.classList.add("hidden");
    document.documentElement.classList.remove("overflow-hidden");
  }

  openDrawerDesktop?.addEventListener("click", openDrawerFunc);
  openDrawerMobile?.addEventListener("click", openDrawerFunc);
  closeDrawerBtn?.addEventListener("click", closeDrawerFunc);
  overlay?.addEventListener("click", closeDrawerFunc);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !drawer.classList.contains("translate-x-full")) closeDrawerFunc();
  });

  updateActiveNavLink();
}

// Active link highlight
export function updateActiveNavLink() {
  const currentPath = window.location.pathname;
  document.querySelectorAll(".nav-link").forEach((link) => {
    const route = link.getAttribute("data-route");
    if (route === currentPath || (currentPath !== "/" && currentPath.startsWith(route))) {
      link.classList.remove("text-gray-600");
      link.classList.add("text-primary-600", "bg-primary-50");
    } else {
      link.classList.remove("text-primary-600", "bg-primary-50");
      link.classList.add("text-gray-600");
    }
  });
}
